// extracted by mini-css-extract-plugin
module.exports = {"root":"Intro_root__KIGGY","sideBySide":"Intro_sideBySide__8DSWb"};